import produce, { enableMapSet } from 'immer';
import { createStore } from './zustand';
export function createExpandableObjectIdsStore() {
  enableMapSet();
  return createStore((set, __get, __api) => ({
    expandedObjectIds: new Set(),
    expandRow: objectId => set(produce(draft => {
      draft.expandedObjectIds.add(objectId);
    })),
    collapseRow: objectId => set(produce(draft => {
      draft.expandedObjectIds.delete(objectId);
    })),
    collapseAll: () => set({
      expandedObjectIds: new Set()
    })
  }), {
    devtools: {
      name: 'ExpandableObjectIdsStore'
    }
  });
}